import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { config } from '../../../../config.js'
import CommonFetch from '../../../requests/commonFetch'

const API = config.apiUrl

const ReferrerCode = props => {
    let { referrerCode, changeReferrerCode } = props

    if (!referrerCode) {
        getReferrerCodeData(changeReferrerCode)
        return null
    } else {
        return getReferrerCodeComponent(referrerCode)
    }
}

const getReferrerCodeData = changeReferrerCode => {
    CommonFetch({
        path: 'ui/investor_settings/get_userdata',
        method: 'GET',
    })
        .then(data => {
            if (data.success) {
                changeReferrerCode(data['referrer_code'])
            }
        })
}

const getReferrerCodeComponent = referrerCode => {
    const translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]
    return (
        <div className="referrer-code">
            <p className="referrer-code__title">
                {translation['Referrer code']}
            </p>
            <h3 className="referrer-code__value">{referrerCode}</h3>
            <CopyToClipboard
                text={`${API}#/registration?referrer_code=${referrerCode}`}
            >
                <button className="referrer-code__button">
                    {translation['Copy link']}
                </button>
            </CopyToClipboard>
        </div>
    )
}

export default ReferrerCode
